/** Recuperação da sessão no boot (`kernel.initialize()`), com leitura síncrona de “já terminou”. */
export interface SessionReady {
  promise: Promise<void>;
  settled(): boolean;
}

export function trackSession(initialize: Promise<void>): SessionReady {
  let done = false;
  const promise = initialize.then(() => {
    done = true;
  });
  return { promise, settled: () => done };
}
